import { useRef } from 'react';

import Button from 'shared/components/button/Button';
import ChatBubble from 'shared/components/icon/ChatBubble';
import Locked from 'shared/components/icon/Locked';
import User from 'shared/components/icon/User';
import { getText } from 'shared/utils/Text';

import styles from './index.module.scss';

const CollaborationButton = ({
  onClick,
  collaborators,
  showReadOnlyLock,
  comments,
  readUserCommentCount,
  isCollaborationCenterOpen,
  claimStatus,
}) => {
  const myId = collaborators.find(collaborator => collaborator.self)?.id;
  const claimedByOther =
    claimStatus.claimed && claimStatus.currentOwner !== myId;
  const claimedBySelf =
    claimStatus.claimed && claimStatus.currentOwner === myId;

  const userComments = (comments || []).filter(
    comment => comment.commentType === 'UserMessage',
  );

  const initialUserCommentCount = useRef(userComments.length);

  const readUserComments = Math.max(
    initialUserCommentCount.current,
    readUserCommentCount,
  );
  const unreadUserComments = userComments.length - readUserComments;

  let lock;
  if (showReadOnlyLock) {
    lock = (
      <div className={styles.readOnly}>
        <Locked className={styles.lock} />
      </div>
    );
  } else if (claimedBySelf) {
    lock = (
      <div className={styles.claimedByMe}>
        <Locked className={styles.lock} />
      </div>
    );
  } else if (claimedByOther) {
    lock = (
      <div className={styles.claimedByOther}>
        <Locked className={styles.lock} />
      </div>
    );
  }

  return (
    <Button className={styles.collaborationButton} onClick={onClick}>
      <div>{getText('collaborate-title')}</div>
      <div>
        <User className={styles.user} />
        <span className={styles.number}>{collaborators.length}</span>
      </div>
      <div>
        <ChatBubble className={styles.chat} />
        <span className={styles.number}>{userComments.length}</span>
        {!isCollaborationCenterOpen && unreadUserComments > 0 && (
          <span className={styles.unread}>{unreadUserComments}</span>
        )}
      </div>
      {lock}
    </Button>
  );
};

export default CollaborationButton;
